import React from 'react'
import { connect } from 'react-redux'
// import { Button } from '@material-ui/core'
import * as actions from '../../actions'
// import { COLORES } from '../../../../config/colores'
import IconButton from '@material-ui/core/IconButton'
import Tooltip from '@material-ui/core/Tooltip'
import EditIcon from '@material-ui/icons/Edit'
import DeleteIcon from '@material-ui/icons/Delete'

function OperacionesCupoNominadoView (props) {
  const { cupo, openDialogRenominacion, deleteCupoNominado } = props

  return (
    <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'nonwrap' }}>
      <Tooltip title={'Editar'}>
        <IconButton onClick={() => openDialogRenominacion(cupo)} style={{ outline: 'none' }}>
          <EditIcon />
        </IconButton>
      </Tooltip>
      <Tooltip title={'Eliminar'}>
        <IconButton onClick={() => deleteCupoNominado(cupo)}>
          <DeleteIcon />
        </IconButton>
      </Tooltip>
      {/* <Button style={{ color: COLORES.green.medium }} onClick={() => openDialogRenominacion(cupo)}>
          RENOMINAR
      </Button>
      <Button style={{ color: COLORES.red.medium }} onClick={() => deleteCupoNominado(cupo)}>
            ELIMINAR
      </Button> */}
    </div>
  )
}

export default connect(null, actions)(OperacionesCupoNominadoView)
